import IPlugin from "./plugin";
import VueSignaturePad from 'vue-signature-pad';

export default class SignaturePlugin extends IPlugin {
    setup(Vue, config) {
        Vue.use(VueSignaturePad);
        return super.setup(Vue, config);
    }
}